import axios from 'axios';

/*
 * SETUP
 * -----
 */

const baseUrl =
  window.location.host === 'wheelseye.com'
    ? 'https://wheelseye.com/fuel/onboard' // Production URL
    : 'http://trucking-web.stage.wheelseye.in/fuel/onboard'; // Staging URL

export const fuelOnboardingAxios = axios.create();

/*
 * APIs
 * ----
 */

export const getOperatorCount = (instance) => {
  return instance
    .get(`${baseUrl}/operator/count`)
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return Promise.reject(error);
    });
};

export const postNewOperator = (instance, params) => {
  return instance
    .post(`${baseUrl}/operator/new`, params)
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return Promise.reject(error);
    });
};
